import {
  Component,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-portal-detail-drawer',
  templateUrl: './portal-detail-drawer.component.html',
  styleUrls: ['./portal-detail-drawer.component.scss'],
})
export class PortalDetailDrawerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() variant: 'task' | 'invoice' | 'default' = 'default';
  @Input() drawerTitle = '';
  @Input() cardClass = '';
  @Input() resetScrollKey: unknown;
  @Input() hideTopbar = false;
  @Output() backClick = new EventEmitter<void>();
  @Output() closeClick = new EventEmitter<void>();
  @ViewChild('drawerContent') drawerContent?: ElementRef<HTMLElement>;
  private scrollTimer: ReturnType<typeof window.setTimeout> | null = null;

  ngAfterViewInit() {
    this.scrollContentToTop();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetScrollKey']) {
      this.scrollContentToTop();
    }
  }

  ngOnDestroy() {
    this.clearScrollTimer();
  }

  private scrollContentToTop() {
    this.clearScrollTimer();
    this.scrollTimer = window.setTimeout(() => {
      if (this.drawerContent?.nativeElement) {
        this.drawerContent.nativeElement.scrollTop = 0;
      }
      this.scrollTimer = null;
    });
  }

  private clearScrollTimer() {
    if (this.scrollTimer) {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
  }
}
